import type { PropsWithChildren } from 'react';

import { TableBannerStyled } from './styles/TableBannerStyled'
import { TableCell } from './TableCell'
import { TableRow } from './TableRow'
import { type Enum } from '@ui/utils/enums'

export const TableBannerTypes = {
  DEFAULT: 'default',
  ERROR: 'error',
} as const
export type TableBannerType = Enum<typeof TableBannerTypes>
export interface ITableBannerProps {
  type?: TableBannerType
  align?: 'right' | 'left' | 'center'
}

export const TableBanner = ({
  type = 'default',
  align = 'center',
  children,
}: PropsWithChildren<ITableBannerProps>) => {
  return (
    <TableRow hoverable={false}>
      <TableCell colSpan={100} align={align} style={{ padding: 0 }}>
        <TableBannerStyled type={type}>{children}</TableBannerStyled>
      </TableCell>
    </TableRow>
  )
}
